import type { WorkspaceDesk } from '@/config/workspace-desk'
import type { StaffNavContext } from './staff-nav-context'
import { mergeDeskNavProfile } from './workspace-desk-nav-profiles'

/** Limits sidebar IA on desk subdomains; permissions still gate each leaf. */
export function applyWorkspaceDeskNavProfile(
  ctx: StaffNavContext,
  desk: WorkspaceDesk | null,
): StaffNavContext {
  if (!desk) {
    return ctx
  }
  return mergeDeskNavProfile(ctx, desk)
}
